﻿$(function () {
    var culture = $.datepicker.regional.bookhuscurrent;
    var localizedStrings = {
        tilmeld: {
            'da': 'Tilmeld',
            'en-GB': 'Sign up',
            'de': 'Abonnieren',
            'sv': 'Prenumerera',
            'no': 'Abonnere'
        }
    }


    var html =
        '<div class="input-group mb-3">' +
            '<input type="text" id="txtTilmeldnyhedsbrev" name="txtTilmeldnyhedsbrev" class="form-control">' +
            '<div class="input-group-append">' +
        '<button type="button" id="btnTilmeld" name="btnTilmeld" class="btn btn-primary">' + (localizedStrings.tilmeld[culture] || 'Tilmeld') + '</button>' +
            '</div>' +
        '</div>';
    $('.tilmeldnyhedsbrev').html(html);
    $('#btnTilmeld').on('click', function () {
        $.ajax({
            url: '/api/component/NewsLetterRegistration?email=' + $('#txtTilmeldnyhedsbrev').val(),
            type: 'post',
            error: function (xhr, status, error) {
                swal.fire({
                    text: xhr.responseText,
                    icon: 'error',
                    timer: 4000
                });
            },
            success: function (data) {
                swal.fire({
                    text: data,
                    icon: 'success',
                    timer: 4000
                });
            }
        });
    });

})